export let isUWPApp = false;
export let isIOSApp = false;
export let isAndroidApp = false;

export function setIsUWPApp(val: boolean) { isUWPApp = val; }
export function setIsIOSApp(val: boolean) { isIOSApp = val; }
export function setIsAndroidApp(val: boolean) { isAndroidApp = val; }

export function getAppOrBrowserString(): string {
  return (isUWPApp || isIOSApp || isAndroidApp) ? 'app' : 'browser';
}

// Expose setIOSApp globally for native app to call
(window as any).setIOSApp = (isApp: boolean) => {
  isIOSApp = isApp;
};
